import { fg } from '@atlaskit/platform-feature-flags';

const ModalSizes = {
	SMALL: 'small',
	MEDIUM: 'medium',
	LARGE: 'large',
	XLARGE: 'xlarge',
	MAX: 'max',
	FULLSCREEN: 'fullscreen',
} as const;

export type ModalSizesType = (typeof ModalSizes)[keyof typeof ModalSizes];
type ModalDimensions = { height: string; minHeight?: string };

const modalDimensions: {
	[viewportSize in ModalSizesType]: ModalDimensions;
} = {
	[ModalSizes.SMALL]: { height: '20vh', minHeight: '320px' },
	[ModalSizes.MEDIUM]: { height: '40vh', minHeight: '520px' },
	[ModalSizes.LARGE]: { height: '70vh', minHeight: '720px' },
	[ModalSizes.XLARGE]: { height: '90vh' },
	[ModalSizes.MAX]: { height: '100%' },
	[ModalSizes.FULLSCREEN]: { height: '100%'},
};

export const getModalDimensions = (size: ModalSizesType): ModalDimensions => {
	if (fg('destructure-getmodaldimensions-with-failsafe')) {
		const safeSize = modalDimensions[size] ? size : 'medium';
		return modalDimensions[safeSize];
	}

	return modalDimensions[size];
};
